module.exports = __webpack_public_path__ + "img/facebook.cc3f0561.svg";